// src/pages/calidad/PiezasProducidasCaptura.jsx
import { useState, useEffect } from 'react';
import api from '../../services/api';

const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

export default function PiezasProducidasCaptura() {
  const hoy = new Date();
  const [anio, setAnio] = useState(hoy.getFullYear());
  const [mes, setMes] = useState(hoy.getMonth() + 1);
  const [piezas, setPiezas] = useState('');
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  async function cargar() {
    setCargando(true);
    setMensaje(null);
    try {
      const res = await api.get('/api/calidad/quejas-cliente/piezas-producidas', { params: { anio, mes } });
      setPiezas(res.data.data ? String(res.data.data.piezas_producidas) : '');
    } catch (err) {
      console.error(err);
      setPiezas('');
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, [anio, mes]); // eslint-disable-line react-hooks/exhaustive-deps

  async function handleGuardar() {
    if (!piezas || Number(piezas) <= 0) {
      setMensaje({ tipo: 'error', texto: 'Ingresa un número de piezas válido.' });
      return;
    }
    try {
      setGuardando(true);
      setMensaje(null);
      await api.put('/api/calidad/quejas-cliente/piezas-producidas', { anio, mes, piezas_producidas: Number(piezas) });
      setMensaje({ tipo: 'ok', texto: `✓ Piezas de ${MESES[mes - 1]} ${anio} guardadas.` });
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || 'No se pudo guardar.' });
    } finally {
      setGuardando(false);
    }
  }

  return (
    <div style={styles.contenedor} className="contenedor-captura">
      <h1 style={styles.titulo}>Piezas Producidas (mensual)</h1>
      <p style={styles.subtitulo}>Denominador del KPI 5.2 — captura manual, una vez al mes.</p>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      <div style={styles.tarjeta}>
        <div className="fila2">
          <div style={styles.grupo}>
            <label style={styles.label}>Mes</label>
            <select value={mes} onChange={(e) => setMes(Number(e.target.value))} style={styles.input}>
              {MESES.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select>
          </div>
          <div style={styles.grupo}>
            <label style={styles.label}>Año</label>
            <input type="number" value={anio} onChange={(e) => setAnio(Number(e.target.value))} style={styles.input} />
          </div>
        </div>

        <div style={styles.grupo}>
          <label style={styles.label}>Piezas producidas {cargando && '(cargando...)'}</label>
          <input type="number" value={piezas} onChange={(e) => setPiezas(e.target.value)} style={styles.input} placeholder="Ej. 312553" disabled={cargando} />
        </div>

        <button onClick={handleGuardar} disabled={guardando || cargando} style={styles.botonGuardar}>
          {guardando ? 'Guardando...' : 'Guardar'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '480px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '18px' },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', display: 'flex', flexDirection: 'column', gap: '14px' },
  grupo: { display: 'flex', flexDirection: 'column', gap: '5px' },
  label: { fontSize: '12px', fontWeight: 600, color: '#6E4F80' },
  input: { padding: '8px 10px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7', width: '100%', boxSizing: 'border-box' },
  botonGuardar: { padding: '12px', fontSize: '14px', fontWeight: 700, color: '#fff', background: '#6A2C75', border: 'none', borderRadius: '8px', cursor: 'pointer' },
};